import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { OperatorService } from '../../../services/operator.service';
import { finalize } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';

interface TlrItem {
  id: string;
  status: string;
}

@Component({
    selector: 'app-operation-overview',
    imports: [
        CommonModule,
        TableModule,
        ButtonModule
    ],
    providers: [],
    templateUrl: './operation-overview.component.html',
    styleUrl: './operation-overview.component.scss'
})
export class OperationOverviewComponent implements OnInit {
  // Data array for TLR items
  tlrItems: TlrItem[] = [];
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private notificatoinService: NotificationService,
    private operatorService: OperatorService
  ) { }

  ngOnInit(): void {
    this.loadOperatorList();
  }

  // Load operator list from API
  loadOperatorList(): void {
    this.isLoading = true;
    this.operatorService.GetOperatorListView()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (response) => {
          if (response) {
            this.mapOperatorList(response);
          }
        },
        error: (error) => {
          this.notificatoinService.showError('Failed to load TLR data');
        }
      });
  }

  // Map API response to component data model
  mapOperatorList(data: any[]): void {
    if (!data || !Array.isArray(data)) {
      return;
    }

    this.tlrItems = data.map(item => ({
      id: item.tag_number || '',
      status: this.mapTlrStatus(item.tlr_status || '')
    }));
  }

  // Helper function to map TLR status codes to readable text
  mapTlrStatus(code: string): string {
    const statusMap: { [key: string]: string } = {
      'I': 'Installed',
      'R': 'Removed',
      'P': 'Pre-Installation'
    };
    return statusMap[code] || code;
  }

  onDetailsClick(id: string): void {
    this.router.navigate([`/details-section/${id}`]);
  }

  onDeleteClick(id: string): void {
    // Show confirmation before deleting
    if (confirm(`Are you sure you want to delete TLR with ID: ${id}?`)) {
      this.isLoading = true;
      this.operatorService.deleteOperatorTag(id)
        .pipe(finalize(() => this.isLoading = false))
        .subscribe({
          next: (response) => {
            this.notificatoinService.showSuccess(`TLR ID: ${id} has been successfully deleted`);
            this.tlrItems = this.tlrItems.filter(item => item.id !== id);
          },
          error: (error) => {
            this.notificatoinService.showError(`Failed to delete TLR ID: ${id}`);
            console.error('Delete operation failed:', error);
          }
        });
    }
  }

  onEditClick(tagNumber: string): void {
    this.router.navigate([`/operation-create-new-tlr-repump/update/${tagNumber}`]);
  }

  onRepumpClick(tagNumber: string): void {
    this.router.navigate([`/operation-create-new-tlr-repump/repump/${tagNumber}`]);
  }
}
